﻿import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'react-tooltip';
import { P } from '@Elements/Fonts';
import { Icon_User } from '@Elements/ImageElements/Icons';
import { str_isEmpty } from '@Util/Utils';
import {
    Team_List_Props,
    InTime_User
} from '@Util/Types';

export default function Team_List(props: Team_List_Props): JSX.Element {
    const [t] = useTranslation();

    function render_user_image(team_member: InTime_User): JSX.Element {
        if (team_member?.photo?.fileUrl !== null) {
            return (
                <img
                    data-tooltip-id={`team_member_${team_member.id}`}
                    data-tooltip-place="top"
                    data-tooltip-delay-show={500}
                    src={team_member?.photo?.fileUrl}
                    alt={`${team_member?.firstName} ${team_member?.lastName}`}
                    loading="lazy"
                    style={{ aspectRatio: "1/1" }}
                />
            )
        } else {
            return (
                <div
                    className="Team_List_Item_Image_Placeholder"
                    data-tooltip-id={`team_member_${team_member?.id}`}
                    data-tooltip-place="top"
                    data-tooltip-delay-show={500}
                >
                    <Icon_User />
                </div>
            )
        }
    }

    function render_tooltip(team_member: InTime_User): JSX.Element {
        return (
            <Tooltip id={`team_member_${team_member?.id}`} opacity="1">
                <div className="Team_List_Item_Tooltip">
                    {
                        !str_isEmpty(team_member?.firstName) && !str_isEmpty(team_member?.lastName) &&
                        <P bold={true}>{`${team_member?.firstName} ${team_member?.lastName}`}</P>
                    }
                    <P>
                        <strong>{`${t('Text.Status')}:`}</strong>
                        {
                            team_member?.current?.customerName !== null ?
                                "Online" :
                                "Offline"
                        }
                    </P>
                    {
                        team_member?.current?.customerName !== null && !str_isEmpty(team_member?.current?.customerName) && !str_isEmpty(team_member?.current?.projectName) &&
                        <P>
                            <strong>{`${t('Text.Project')}:`}</strong>
                            {`${team_member?.current?.customerName} - ${team_member?.current?.projectName}`}
                        </P>
                    }
                </div>
            </Tooltip>
        )
    }

    if (props.data.isEmpty()) {
        return;
    }

    return (
        <ul className="Team_List" data-offline={props.offline}>
            {props.data.map((team_member: InTime_User, index: number): JSX.Element =>
                <li
                    key={`team_user${index}_id${team_member?.id}`}
                    className="Team_List_Item"
                    style={{ border: `3px solid rgb(${team_member?.current?.color})` }}
                >
                    {render_user_image(team_member)}
                    {render_tooltip(team_member)}
                </li>
            )}
        </ul>
    );
}